import * as React from "react";
import { CommandBar, MessageBar, MessageBarType, Panel, PanelType, Selection } from "office-ui-fabric-react";
import { getPendingBookings } from "../../../api/bookings";
import { IBooking, IMyBooking } from "../../../types/Booking.types";
import { BookingList } from "./MyBookingList";

import styles from "./MyBookings.module.scss";
import { RoomBookingForm } from "../forms/RoomBookingForm";

export interface IPendingApprovalProps {
    onDismiss: () => void;
}

export const PendingApproval = (props: IPendingApprovalProps) => {
    const { onDismiss } = props;

    const [ bookings, setBookings ] = React.useState<IBooking[]>();
    const [ bookingSelected, setBookingSelected ] = React.useState<IBooking|undefined>();
    const [ viewRoomBooking, setViewRoomBooking ] = React.useState<IBooking|undefined>();
    const [ error, setError ] = React.useState<string>();

    const onSelectionChanged = React.useCallback(function (this: Selection) {
        const selectedItems = this.getSelection() as IMyBooking[];
        if (selectedItems !== undefined && selectedItems.length > 0) {
            setBookingSelected(selectedItems[0] as IMyBooking);
        } else {
            setBookingSelected(undefined);
        }
    }, []);
    
    const [ selection ] = React.useState(new Selection({ onSelectionChanged: onSelectionChanged }));

    const _load = async (abortController: AbortController) => {
        const response = await getPendingBookings(abortController);
        if (!(response instanceof Error)) {
            setBookings(response);
        } else {
            setError(response.message);
        }
    }

    React.useEffect(() => {
        const abortController = new AbortController();
        _load(abortController);

        return () => {
            abortController.abort();
        }
    }, []);
    
    return (
        <Panel type={PanelType.custom} customWidth="1200px" isOpen={true} headerText="Booking Approval" onDismiss={onDismiss}>
            { error !== undefined && (
                <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>
            )}
            <p>Approve or reject booking requests::</p>
            { window.innerWidth < 640 && (
                <MessageBar messageBarType={MessageBarType.info}>You can scroll the table below with the mouse or your finger</MessageBar>
            )}
            <CommandBar
                className={styles.commandBar}
                items={[
                    {
                        disabled: !bookingSelected,
                        key: "view",
                        text: window.innerWidth < 640 ? "View" : "View Booking",
                        onClick: () => {
                            if (bookingSelected) {
                                setViewRoomBooking(bookingSelected);
                            }
                        }
                    },
                ]}
            />
            { bookings !== undefined && bookings.length > 0 && (
                <BookingList 
                    isApprovalMode={true}
                    label="Bookings pending approval"
                    listKey="pending"
                    selection={selection}
                    bookings={bookings}
                    onChange={(reload, error) => {
                        if (error) {
                            setError(error.message);
                        }
                        if (reload) {
                            _load(new AbortController());
                        }
                    }}
                />
            )}
            { viewRoomBooking !== undefined && (
                <RoomBookingForm
                    readOnly={true}
                    finish={new Date(viewRoomBooking.Finish)}
                    onDismiss={(changesMade) => {
                        setViewRoomBooking(undefined);
                        if (changesMade) {
                            _load(new AbortController());
                        }
                    }}
                    booking={viewRoomBooking}
                    roomId={viewRoomBooking.RoomId as number}
                    start={new Date(viewRoomBooking.Start)}
                />
            )}
        </Panel>
    );
};